/* global require, up */

const {invoke} = require("../lib/utils")

/*
  emits event:
  - "carousel:change-slide", {  count: <int>,  idx: <int> }

  listens for events:
  - "carousel:previous-slide"
  - "carousel:next-slide"
  - "keydown"
 */
up.compiler("carousel-container", function(element, data){
  const slide_el       = element.querySelector("[slide]");
  const slide_uris     = data?.map ? data.map((x) => x["file/uri"]) : [];
  const initial_slides = slide_uris.map((x) => "/" + x)
  const slides         = [...initial_slides];
  const slide_count    = initial_slides.length;

  if(!(slide_uris?.map && slide_uris.filter(up.util.isPresent))){
    console.log("carousel-container", element, "has no valid slides")
    return
  }

  let current_slide    = slides.shift();
  slide_el.src           = current_slide;

  function update_progress(){
    const change_slide_event = {
      count: slide_count,
      idx: initial_slides.indexOf(current_slide) + 1
    }
    up.emit(element, "carousel:change-slide", change_slide_event)
  }

  update_progress()

  function next_slide() {
    slides.push(current_slide)
    current_slide = slides.shift()
    slide_el.src = current_slide
    update_progress()
  }

  function prev_slide() {
    slides.unshift(current_slide)
    current_slide = slides.pop()
    slide_el.src = current_slide
    update_progress()
  }

  const handleKeyDn = function(event) {
    switch(event.key){
    case "ArrowRight":
      next_slide();
      break;
    case "ArrowLeft":
      prev_slide();
      break;
    }
  }

  const cleanup = [
    up.on("carousel:previous-slide", prev_slide),
    up.on("carousel:next-slide",     next_slide),
    up.on("keydown", handleKeyDn)
  ]

  return function(){
    cleanup.forEach(invoke)
  };
})
